import { render, staticRenderFns } from "./ComparisonTab.vue?vue&type=template&id=7dc402ac&scoped=true"
import script from "./ComparisonTab.vue?vue&type=script&lang=ts"
export * from "./ComparisonTab.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonTab.vue?vue&type=style&index=0&id=7dc402ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc402ac",
  null
  
)

export default component.exports